import { FormControl } from '@mui/material';
import styled from 'styled-components';

export const FilterStyledFormControl = styled(FormControl)`
  margin-right: 5px;

  &:last-child {
    margin-right: 0;
  }

  .MuiButtonBase-root {
    padding: 0;
  }

  .MuiSelect-root {
    font-size: 12px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const DateTimeInputContainer = styled.div`
  input {
    font-size: 12px;
  }

  .MuiButtonBase-root {
    padding-left: 0;
    padding-right: 5px;
  }

  .MuiIconButton-root:hover {
    background: transparent;
  }
`;
